import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/global.css'; // 确保全局样式生效
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vuex from 'vuex'
import store from './store' //引入store
import VueCookies from 'vue-cookies';
import './assets/scss/element-variables.scss'
// import './element-ui/index.js'
import Vant from 'vant';
import 'vant/lib/index.css';
import {
	Toast
} from 'vant';
import 'swiper/css/swiper.css';
import {
	Lazyload
} from 'vant';
import {
	i18n
} from './i18n/index' //国际化

import {
	getSetting,
} from './api/all.js'


Vue.use(Lazyload);

// import VueCoreVideoPlayer from 'vue-core-video-player'
//     // "vue-video-player": "^5.0.1",s
// Vue.use(VueCoreVideoPlayer)

Vue.use(Toast);
Vue.use(Vant);
Vue.use(VueCookies)

Vue.use(Vuex)

Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')